<template lang="pug">
  div.boxFilterCompare
    ods-row(type='flex' justify='space-between' align='middle')
      div.inputBox
        div.compareBox
          span.text-separator {{$t('compare')}}
          ods-select(
            v-model='categorySelected'
            placeholder='Elige Categoría'
            @change=''
          )
            ods-option(
              v-for='item in categoriesCompare'
              :key='item.value'
              :label='item.label'
              :value='item.value')
        div.intervalBox
          span.text-separator {{$t('Of the interval 1')}}
          ods-date-picker(
            v-model="datepicker1"
            type="daterange"
            range-separator="-"
            start-placeholder="dd/mm/aaaa"
            end-placeholder="dd/mm/aaaa"
          )
          span.text-separator {{$t('with the interva 2')}}
          ods-date-picker(
            v-model="datepicker2"
            type="daterange"
            range-separator="-"
            start-placeholder="dd/mm/aaaa"
            end-placeholder="dd/mm/aaaa"
          )
          ods-tooltip(class="item" effect="dark" content="Selecciona un árbol" placement="top-start")
            ods-button(type='secondary' size='small' :disabled='buttonCompareDisabled' round @click.native='updateCompareStation("buttonCompare")') {{$t('compare')}}
      div.buttonBackBox
        ods-button(size="small" icon="ods-icon-close" round @click.prevent='$router.push({ name: "ParksAndGardensDashboard" })') {{ $t('cerrar')}}
        //- div.legend
        //-   span.range1 Rango 1
        //-   span.range2 Rango 2
</template>

<script>
import MapZoomParksCompare from '@/components/MapZoomParksCompare'
import StatusCero from '@/components/StatusCero'
import PopupCompare from '@/components/PopupCompare'

export default {
  name: 'MapCompare',
  data () {
    return {
      categorySelected: 0,
      categoriesCompare: [{
        value: 0,
        label: 'Máximos'
      }, {
        value: 1,
        label: 'Mínimos'
      }, {
        value: 2,
        label: 'Media'
      }],
      opened: false,
      datepicker1: ['2018-11-01T23:00:00.000Z', '2018-11-03T23:00:00.000Z'],
      datepicker2: ['2018-11-11T23:00:00.000Z', '2018-11-13T23:00:00.000Z'],
      kpisStation: [],
      datos1: [],
      datos2: [],
      datosFinal: [],
      dataCompare: true,
      dataCompareLoad: true,
      stationName: null,
      valorComparado: null,
      buttonCompareDisabled: true,
      loading: true
    }
  },
  computed: {
    getStationsCompare () {
      let array = []
      array = this.$store.getters.getCompareStations
      return array
    }
  },
  watch: {
    getStationsCompare (val) {
      const component = this
      if (val) {
        component.kpisStation.push(val)
        component.aplicar()
      }
    }
  },
  methods: {
    aplicar () {
      const component = this
      component.datos1 = []
      component.datos2 = []
      component.datosFinal = []
      for (var i = 0; i < component.kpisStation.length; i++) {
        for (var j = 0; j < component.kpisStation[i].comparativeDate1.length; j++) {
          // console.log(component.kpisStation[i].comparativeDate1)
          let array = {
            tipo: component.kpisStation[i].comparativeDate1[j].measureType,
            max: component.kpisStation[i].comparativeDate1[j].kpiMaxValue,
            min: component.kpisStation[i].comparativeDate1[j].kpiMinValue,
            media: component.kpisStation[i].comparativeDate1[j].kpiMediaValue,
            from: component.kpisStation[i].comparativeDate1[j].from,
            to: component.kpisStation[i].comparativeDate1[j].to,
            unit: component.kpisStation[i].comparativeDate1[j].kpiUnit
          }
          component.datos1.push(array)
        }
        for (var k = 0; k < component.kpisStation[i].comparativeDate2.length; k++) {
          // console.log(component.kpisStation[i].comparativeDate2)
          let array = {
            tipo: component.kpisStation[i].comparativeDate2[k].measureType,
            max: component.kpisStation[i].comparativeDate2[k].kpiMaxValue,
            min: component.kpisStation[i].comparativeDate2[k].kpiMinValue,
            media: component.kpisStation[i].comparativeDate2[k].kpiMediaValue,
            from: component.kpisStation[i].comparativeDate2[k].from,
            to: component.kpisStation[i].comparativeDate2[k].to,
            unit: component.kpisStation[i].comparativeDate2[k].kpiUnit
          }
          component.datos2.push(array)
        }
      }
      if (component.datos1.length > 0 && component.datos2.length > 0) {
        component.getValue(component.categorySelected)
        component.dataCompareLoad = false
        component.dataCompare = true
      } else {
        component.dataCompareLoad = false
        component.dataCompare = false
      }
      component.updateEmitCompareData()
    },
    getValue (select) {
      const component = this
      for (var i = 0; i < component.datos1.length; i++) {
        if (component.datos1[i].tipo === component.datos2[i].tipo) {
          // console.log(component.datos1[i].tipo + ' || ' + component.datos2[i].tipo)
          // console.log('uno ' + component.datos1[i].max)
          // console.log('dos ' + component.datos2[i].max)
          var mediaMax = (component.datos1[i].max + component.datos2[i].max) / 2
          var mediaMin = (component.datos1[i].min + component.datos2[i].min) / 2
          var mediaMedia = (component.datos1[i].media + component.datos2[i].media) / 2
          var valor, tipoValor
          if (select === 0) {
            valor = mediaMax
            tipoValor = 'Máximos'
          } else if (select === 1) {
            valor = mediaMin
            tipoValor = 'Mínimos'
          } else if (select === 2) {
            valor = mediaMedia
            tipoValor = 'Media'
          } else {
            valor = null
            tipoValor = null
          }
          var array = {
            tipo: component.datos1[i].tipo,
            valor: valor,
            tipoValor: tipoValor,
            unit: component.datos1[i].unit
          }
          component.valorComparado = tipoValor
          component.datosFinal.push(array)
        }
      }
    },
    updateEmitCompareData () {
      const component = this
      var data = [component.stationName, component.valorComparado, component.dataCompare, component.dataCompareLoad, component.datosFinal]
      component.$emit('updateStationCompare', data)
      component.opened = true
    },
    updateSelectedStation () {
      this.stationSelected = null
    },
    getSelectedStation (val) {
      const component = this
      component.stationSelected = val
      component.kpisStation = []
      component.datos1 = []
      component.datos2 = []
      component.datosFinal = []
      component.dataCompareLoad = true
      component.dataCompare = true
      component.updateEmitCompareData()
      component.updateCompareStation()
    },
    updateCompareStation (val) {
      const component = this
      component.kpisStation = []
      component.datos1 = []
      component.datos2 = []
      component.datosFinal = []
      component.dataCompareLoad = true
      component.dataCompare = true
      // var listTypes = ['ground', 'irrigation', 'incidence', 'co2Absorption']
      if (component.stationSelected) {
        component.stationName = component.stationSelected.name
        if (component.stationSelected.id !== 'city') {
          component.buttonCompareDisabled = false
          if (val === 'buttonCompare') {
            // for (var i = 0; i < listTypes.length; i++) {
            let inData = {
              type: 'infoParques',
              from1: new Date(component.datepicker1[0]).toJSON(),
              to1: new Date(component.datepicker1[1]).toJSON(),
              from2: new Date(component.datepicker2[0]).toJSON(),
              to2: new Date(component.datepicker2[1]).toJSON(),
              id: component.stationSelected.id
            }
            this.$store.dispatch('updateCompareStations', inData)
            // }
          } else {
            let inData = {
              type: component.stationSelected.subtype,
              from1: new Date(component.datepicker1[0]).toJSON(),
              to1: new Date(component.datepicker1[1]).toJSON(),
              from2: new Date(component.datepicker2[0]).toJSON(),
              to2: new Date(component.datepicker2[1]).toJSON(),
              id: component.stationSelected.id
            }
            if (new Date(component.datepicker1[0]).toJSON() === null) {
              inData.from1 = '2018-11-01T23:00:00.000Z'
            }
            if (new Date(component.datepicker1[1]).toJSON() === null) {
              inData.to1 = '2018-11-03T23:00:00.000Z'
            }
            if (new Date(component.datepicker2[0]).toJSON() === null) {
              inData.from2 = '2018-11-11T23:00:00.000Z'
            }
            if (new Date(component.datepicker2[1]).toJSON() === null) {
              inData.to2 = '2018-11-13T23:00:00.000Z'
            }
            this.$store.dispatch('updateCompareStations', inData)
          }
        } else {
          if (val === 'buttonCompare') {
            component.buttonCompareDisabled = false
          }
          component.buttonCompareDisabled = true
          component.dataCompareLoad = true
          component.dataCompare = false
        }
        component.updateEmitCompareData()
      } else {
        component.buttonCompareDisabled = false
      }
    }
  },
  components: {
    MapZoomParksCompare,
    StatusCero,
    PopupCompare
  },
  mounted () {
    const component = this
    window.document.addEventListener('setPopupCompare', setPopupCompare, false)
    function setPopupCompare (e) {
      component.$emit('setPopupCompare', e.detail)
      // Desabilitamos el btoón de comparar cuando no hay ningún árbol seleccionado
      if (e.detail === false) {
        component.buttonCompareDisabled = true
      }
    }
  }
}
</script>

<style lang="scss">

// Cuando Beltrán suba el componente del datepicker con el separator junto a los inputs  borrarlo
.ods-input__inner{
  border-right: 1px solid transparent;
  border-left: 0;
  &:first-child {
    border-left: 1px solid transparent;
    border-right: 0;
  }
}
.ods-date-editor--daterange.is-active{
  .ods-input__inner{
    border-left: 0;
    border-left-color: transparent;
    &:first-child {
      border-left: 1px solid #2E6C99;
      border-right-color: transparent;
      border-right: 0;
    }
  }
  .ods-range-separator{
    border-top-color: #2E6C99;
    border-bottom-color: #2E6C99;
  }
}
.ods-range-separator {
  padding: 0 8px !important;
  background: #f0f5f8;
  height: 30px;
  display: inline-block;
  line-height: 3.6;
  border: 1px solid transparent;
  border-left: 0;
  border-right: 0;
  border-bottom-color: #A2ACB3;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
// Fin de Cuando Beltrán suba el componente del datepicker con el separator junto a los inputs  borrarlo
</style>

<style lang="scss" scoped>

  .environment-dashboard{
    height: 100%;
  }

  #mapContainer /deep/ {
    right: 0;
  }

  .map-tools {
    display: block;
    margin: 0;
    margin: rem(16);
    position: absolute;
    width: calc(70% - 104px);
    z-index: 20;
    .ods-row  + .ods-row {
      margin-top: rem(8);
    }
    .ods-button + .ods-button {
      margin-left: 0;
    }
    a.router-link-active:visited {
      color: $--color-white;
    }
  }

  .boxFilterCompare{
    & > div{
      // transform: rotate(20deg);
      // transition: transform 1s;
      background: $--color-white;
      border: 1px solid #e0e0e0;
      position: relative;
      z-index: 1;
    }
    .compareBox {
      /* border-right: 1px solid $--color-grey-light; */
      padding: rem(22) rem(28);
      padding-right: 0;
      display: inline-block;
      span {
        margin-right: rem(16);
      }
      .ods-select {
        width: auto;
      }
    }
    .text-separator {
      color: $--color--grey-medium;
      font-size: rem(9  );
      height: auto;
      line-height: rem(16);
      font-weight: 500;
      text-transform: uppercase;
      width: auto;
    }
    .intervalBox {
      display: inline-block;
      padding: rem(22) rem(28);
      span {
        margin-right: rem(16);
        line-height: rem(16);
      }
      .ods-select {
        margin-right: rem(16);
        width: auto;
      }
      /deep/ .ods-date-editor {
        margin-right: rem(16);
        // .ods-date-editor--daterange.is-active{
        //   .ods-input__inner{
        //     &:first-child{
        //       border-right: 0;
        //     }
        //     &:last-child{
        //       border-left: 0;
        //     }
        //   }
        //   .ods-range-separator{
        //     border: 1px solid #ff00ff;
        //   }
        // }
        // .ods-range-separator {
        //   padding: 0 8px;
        //   background: #f0f5f8;
        //   height: 31px;
        //   display: inline-block;
        //   line-height: 3.8;
        //   border-bottom: 1px solid #ff00ff;
        // }
        .ods-icon-date {
          display: none !important;
        }
        .ods-range-input{
          background: transparent;
        }
        .ods-range__close-icon {
          display: none !important;
        }
      }
      .legend {
        display: inline-block;
        vertical-align: middle;
        margin-left: rem(16);
        span {
          color: $--color--grey-medium;
          display: block;
          font-size: rem(9);
          font-weight: 500;
          line-height: rem(16);
          margin-right: rem(40);
          text-transform: uppercase;
          &::before {
            content: '';
            background: $--color-primary;
            border-radius: 100%;
            display: inline-block;
            height: rem(10);
            margin-right: rem(10);
            vertical-align: middle;
            width: rem(10);
          }
          &.range1::before {
            background: $--color-primary;
          }
          &.range2::before {
            background: $--color-secondary;
          }
        }
      }
    }
    .buttonBackBox {
      padding: rem(22) rem(28);
      padding-left: 0;
      /deep/ .ods-icon-close {
        font-size: 20px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MapCompare.vue